export interface IPermission {
  permission: string;
  rule: string;
}

export interface IPermissionContext {
  accountId: string;
  permissionGroupId: string;
  permissions: IPermission[];
}

export const INITIAL_PERMISSION: IPermissionContext = {
  accountId: '',
  permissionGroupId: '',
  permissions: [],
};
